import styled from 'styled-components';
import React from 'react';

function TextFieldComponent(props: ITextField) {
    return (
        <>
            {props.textArea ? (
                <TextAreaTag
                    {...props}
                    defaultValue={props.defaultValue}
                    disabled={props.disabled ? true : false}
                    onChange={props.onChange}
                />
            ) : (
                <TextFieldTag
                    {...props}
                    min={props.min}
                    defaultValue={props.defaultValue}
                    disabled={props.disabled ? true : false}
                    onChange={props.onChange}
                />
            )}
        </>
    );
}

export default React.memo(TextFieldComponent);

const TextAreaTag = styled.textarea<ITextAreaTag>`
    resize: none;
    padding: 10px;
    border: 1px solid ${({ theme }) => theme.color.borderDefault};
    border-radius: 5px;
    font-size: 14px;
    background-color: ${({ theme }) => theme.color.box};
    width: ${({ theme, defaultSize }) => `
    ${defaultSize ? theme.defaultSize[defaultSize] : theme.defaultSize.full}`};
    color: ${({ theme }) => theme.color.mainFont};

    &::placeholder {
        color: ${({ theme }) => theme.color.placeholder};
    }

    &:disabled {
        background-color: ${({ theme }) => theme.color.tableCategory};
        color: ${({ theme }) => theme.color.fontDisable};
    }
    &:focus {
        outline: none;
        border: 1.5px solid ${({ theme }) => theme.color.borderActive};
    }
`;

const TextFieldTag = styled.input<ITextFieldTag>`
    padding: 10px;
    border: 1px solid ${({ theme }) => theme.color.borderDefault};
    border-radius: 5px;
    font-size: 14px;
    background-color: ${({ theme }) => theme.color.box};
    display: ${({ block }) => (block ? 'block' : 'inline')};
    width: ${({ theme, defaultSize }) => `
    ${defaultSize ? theme.defaultSize[defaultSize] : theme.defaultSize.full}`};
    height: ${({ theme }) => theme.defaultHeight.medium};
    text-align: ${({ textAlign }) => textAlign};
    color: ${({ theme }) => theme.color.mainFont};

    &::placeholder {
        color: ${({ theme }) => theme.color.placeholder};
    }

    &:disabled {
        background-color: ${({ theme }) => theme.color.tableCategory};
        color: ${({ theme }) => theme.color.fontDisable};
    }

    &:focus {
        outline: none;
        border: 1.5px solid ${({ theme }) => theme.color.borderActive};
    }
`;

export interface ITextField {
    min?: string;
    /**
     * 기대 값을 설명하는 짧은 힌트 (jnput placeholder)
     */
    placeholder?: string;

    /**
     * 텍스트 위치
     */
    textAlign?: 'left' | 'right' | 'center';

    /**
     * TextArea 적용 여부
     */
    textArea?: boolean;

    /**
     * TextArea 세로 줄 (textArea == true)
     */
    rows?: number;

    onChange?: any;
    /**
     * 키 입력 이벤트
     */
    onKeyPress?: React.KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>;

    /**
     * 텍스트 필드 타입
     */
    type?: 'text' | 'number';

    /**
     * display Block 여부 (기본 inline)
     */
    block?: Boolean;

    /**
     * 기본 선택 값
     */
    defaultValue?: string | number;

    /**
     * 선택불가처리
     */
    disabled?: boolean;

    /**
     * 너비
     */
    defaultSize?: 'small' | 'medium' | 'large' | 'full';
}

interface ITextFieldTag extends Pick<ITextField, 'block' | 'defaultSize' | 'textAlign' | 'onKeyPress' | 'disabled'> {}

export interface ITextAreaTag extends Pick<ITextField, 'defaultSize' | 'textAlign'> {}
